import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { Link, useLocation } from "react-router-dom";
import MetisMenu from "@metismenu/react";
import "metismenujs/style";
import $ from "jquery";
import { useContext } from "react";
import { NoteState } from "../../../context/notes/NoteState";
import { usesEmployeeOnlyShell } from "../../../utils/roleHome";
import { getVisibleModules } from "./alignedMenuConfig";
import { AlignedMenuItems } from "./AlignedMenu";
import UserServices from "../../../UserServices/UserServices";
import {
  getCachedMenu,
  loadMenuAccess,
  toAlignedModules,
} from "../../../utils/menuAccessCache";

const Sidebar = () => {
  const { state } = useContext(NoteState);
  const { role, designation_id } = state;
  const locate = useLocation();
  const roleStr = String(role ?? "");

  const staticModules = useMemo(() => getVisibleModules(role), [role]);
  const [dynamicModules, setDynamicModules] = useState(null);

  useEffect(() => {
    if (!roleStr || usesEmployeeOnlyShell(role, designation_id)) {
      setDynamicModules(null);
      return;
    }

    const cached = getCachedMenu(roleStr);
    if (cached?.modules) {
      setDynamicModules(toAlignedModules(cached.modules));
    }

    let cancelled = false;
    loadMenuAccess(
      roleStr,
      () => UserServices.getMyMenuAccess().then((res) => res?.data?.data),
      { refresh: true }
    )
      .then((data) => {
        if (cancelled) return;
        if (data?.modules) {
          setDynamicModules(toAlignedModules(data.modules));
        }
      })
      .catch(() => {
        // Keep static fallback
        if (!cancelled && !cached?.modules) {
          setDynamicModules(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [roleStr, role, designation_id]);

  const backToTop = () => {
    return (
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        600
      ),
      !1
    );
  };

  useLayoutEffect(() => {
    if (window.innerWidth < 992) {
      $(".site-main-design").removeClass("full-show");
      $(".site-footer-main").removeClass("full-show");
      $("#sidebar").addClass("show");
    }
  }, [locate.pathname]);

  const visibleModules = dynamicModules?.length ? dynamicModules : staticModules;

  if (usesEmployeeOnlyShell(role, designation_id)) {
    return (
      <div>
        <main>
          <div
            id="sidebar"
            className="show border-end"
          >
            <div
              id="sidebar-nav"
              className="sidebar-wrapper list-group border-0 rounded-0 text-sm-start min-vh-100"
            >
              <MetisMenu>
                <li
                  className={
                    locate.pathname === "/employee-dashboard" ? "mm-active" : ""
                  }
                >
                  <Link to="/employee-dashboard" onClick={backToTop}>
                    <div className="parent-icon">
                      <i className="bi bi-person-badge-fill"></i>
                    </div>
                    <div className="menu-title">Employee Dashboard</div>
                  </Link>
                </li>
              </MetisMenu>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <main>
        <div
          id="sidebar"
          className="show border-end"
        >
            <div
              id="sidebar-nav"
              className="sidebar-wrapper list-group border-0 rounded-0 text-sm-start min-vh-100"
            >
              {/* Plain metismenu list — expand/collapse is React-controlled in AlignedMenu */}
              <ul className="metismenu" id="menu">
                <AlignedMenuItems
                  modules={visibleModules}
                  pathname={locate.pathname}
                  onNavigate={backToTop}
                />
              </ul>
            </div>
        </div>
      </main>
    </div>
  );
};

export default Sidebar;
